import Image from "next/image";

/** Savira brand glyph (transparent). Size it with `className` (e.g. `h-9 w-auto`). */
export function SaviraMark({ className }: { className?: string }) {
    return (
        <Image
            src="/savira-mark.png"
            alt="Savira"
            width={202}
            height={239}
            className={className}
            priority
        />
    );
}
